import React from 'react';

import moment from 'moment';

import Modal from '../../../../../../../../../../components/Modal';
import AdvisorProfile from '../../../AdvisorProfile';

import './ModuleBlock.scss';

const getJobPositionName = (jobPosition) => {
  if (jobPosition.company !== null) {
    return `${jobPosition.title} at ${jobPosition.company.name}`;
  }
  return jobPosition.title;
};

const renderAdvisor = Advisor => {
  if (Advisor !== null) {
    return (
      <div>
        <img src={IMAGECACHELINK + '/' + IMAGESTAGE + '/300x300/' + Advisor.photo} alt={`${Advisor.first_name} ${Advisor.last_name}`} className='img-circle' />
        <p className='roadmap-module-block__advisor-name'>{`${Advisor.first_name} ${Advisor.last_name}`}</p>
        {Advisor.job_positions && Advisor.job_positions.length > 0 && (
          <div>
            <p className='roadmap-module-block__advisor-job-position'>{getJobPositionName(Advisor.job_positions[0])}</p>
          </div>
        )}
      </div>
    )
  }

  return null;
}

export default (props) => {
  const Data = props['module-block-data'];

  if (Data.advisor !== null) {
    return (
      <div className='upcomingSession__Wrapper roadmap-module-block'>
        <Modal onRef={ref => (this['AdvisorkModalFuture__' + Data.id] = ref)}>
          <AdvisorProfile advisorData={Data.advisor} />
        </Modal>
        <div className='row'>
          <div className='col-md-4'>
            <div className='roadmap-module-block__advisor'>
              {Data.Industry && (
                <p className='roadmap-module-block__module-industry'>{Data.Industry.name}</p>
              )}
              {renderAdvisor(Data.advisor)}
            </div>
          </div>
          <div className='col-md-8'>
            <div className='roadmap-module-block__module'>
              <p className='roadmap-module-block__module-title'>{Data.module.module_name || ''}</p>
              {Data.scheduled_to && (
                <p className='roadmap-module-block__module-date'>{moment(Data.scheduled_to).format('MMM DD, YYYY')}</p>
              )}
              <span style={{ "whiteSpace": "pre-line" }} className='roadmap-module-block__module-description'>{Data.module.student_module_summary || ''}</span>
              <div className="roadmap-module-block__module-feedback">
                <a href='#' onClick={((e) => {
                  e.preventDefault();
                  this['AdvisorkModalFuture__' + Data.id].openModal();
                })}>
                  <span className='fa fa-user' />
                  View advisor profile
              </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return null;
};



// WEBPACK FOOTER //
// ./src/routes/progress-report/routes/ProgressReport/components/ProgressReport/components/LearningRoadmap/components/ModuleBlock/index.js